/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_OriginalInputs */



/**
* | output |
* | --- |
* | "Source Text" |
*
* @param {Metadata_Merge_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_original = /** @type {((inputs?: Metadata_Merge_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelltext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソーステキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto de origem")
	return /** @type {LocalizedString} */ ("Source Text")
});